export default __webpack_public_path__ + "static/media/coffeepass_web_logo_home.442b4885.png";